export default "__VITE_ASSET__BsEDoZjL__"